var _circle, _rect, _path, _path2, _rect2, _path3, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 39.6875,
    fill: "#E9ECEB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.8145,
    y: 20.2842,
    width: 38.9056,
    height: 43.4849,
    rx: 2.36405,
    fill: "white",
    stroke: "#B2B2B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.293 59.7534C58.6322 59.7534 62.9604 55.4251 62.9604 50.0859C62.9604 44.7467 58.6322 40.4185 53.293 40.4185C47.9538 40.4185 43.6255 44.7467 43.6255 50.0859C43.6255 55.4251 47.9538 59.7534 53.293 59.7534Z",
    stroke: "#B2B2B3",
    strokeWidth: 1.96257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3773 62.1703L60.1206 56.9136",
    stroke: "#B2B2B3",
    strokeWidth: 1.96257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33.6753,
    y: 29.1157,
    width: 18.8209,
    height: 1.6366,
    rx: 0.818299,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4073 28.943L31.0939 28.2534L30.4043 27.94L31.0939 27.6265L31.4073 26.9369L31.7208 27.6265L32.4104 27.94L31.7208 28.2534L31.4073 28.943ZM29.9027 26.9369L29.4263 25.9088L28.3981 25.4323L29.4263 24.9559L29.9027 23.9277L30.3792 24.9559L31.4073 25.4323L30.3792 25.9088L29.9027 26.9369ZM24.8874 34.9614C24.6116 34.9614 24.3755 34.8632 24.179 34.6667C23.9826 34.4703 23.8844 34.2342 23.8844 33.9583H25.8905C25.8905 34.2342 25.7923 34.4703 25.5959 34.6667C25.3994 34.8632 25.1633 34.9614 24.8874 34.9614ZM22.8813 33.4568V32.4537H26.8936V33.4568H22.8813ZM23.0067 31.9522C22.43 31.6095 21.9723 31.1498 21.6338 30.573C21.2952 29.9962 21.126 29.3693 21.126 28.6923C21.126 27.6474 21.4917 26.7593 22.2231 26.0279C22.9545 25.2965 23.8426 24.9308 24.8874 24.9308C25.9323 24.9308 26.8204 25.2965 27.5518 26.0279C28.2832 26.7593 28.6489 27.6474 28.6489 28.6923C28.6489 29.3693 28.4796 29.9962 28.1411 30.573C27.8026 31.1498 27.3449 31.6095 26.7682 31.9522H23.0067ZM23.3076 30.9491H26.4673C26.8434 30.6817 27.1339 30.3515 27.3387 29.9586C27.5435 29.5658 27.6459 29.1436 27.6459 28.6923C27.6459 27.9232 27.3784 27.2713 26.8434 26.7363C26.3084 26.2013 25.6565 25.9339 24.8874 25.9339C24.1184 25.9339 23.4664 26.2013 22.9315 26.7363C22.3965 27.2713 22.129 27.9232 22.129 28.6923C22.129 29.1436 22.2314 29.5658 22.4362 29.9586C22.641 30.3515 22.9315 30.6817 23.3076 30.9491Z",
    fill: "#B2B2B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.999,
    y: 18.8145,
    width: 13.9111,
    height: 2.86405,
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProject);
export default __webpack_public_path__ + "static/media/NoProject.b9c1723cf28708c85729dd32fe669e0d.svg";
export { ForwardRef as ReactComponent };